import { render, staticRenderFns } from "./MiddlePostDetail.vue?vue&type=template&id=e1a31d0a&scoped=true&"
import script from "./MiddlePostDetail.vue?vue&type=script&lang=js&"
export * from "./MiddlePostDetail.vue?vue&type=script&lang=js&"
import style0 from "./MiddlePostDetail.vue?vue&type=style&index=0&id=e1a31d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a31d0a",
  null
  
)

export default component.exports